var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.8373 10.2422L16.128 11.9514L17.838 13.6607L19.5465 11.9507L17.8373 10.2422ZM12.003 10.2422L10.293 11.9514L12.003 13.6607L13.7123 11.9507L12.003 10.2422ZM6.16728 10.2594L4.45728 11.9687L6.16728 13.6779L7.87653 11.9679L6.16728 10.2594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37097 9.10651L12.0195 4.45801L16.6155 9.05476L14.9235 10.7468L12.0195 7.84201L9.06297 10.7985L7.37097 9.10651ZM16.6162 14.8515L11.9677 19.5L7.37097 14.9033L9.06297 13.2113L11.9677 16.116L14.9242 13.1595L16.6162 14.8515Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.b610b7fa48c38b16e55cb92c73a6dc83.svg";
export { ForwardRef as ReactComponent };